import * as CONST from '../ActionTypes';

const initialState = {
  isLoggedIn: false,
  errorMessage: '',
  accessToken: '',
  refreshToken: '',
  customer: null,
  addresses: [],
  isSuccess: false,
  isFailure: false,
  masked_card_number: '',
  company: '',
};

function auth(state = initialState, action) {
  switch (action.type) {
    // -----------------
    // ログイン
    // -----------------
    case CONST.LOGIN_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        errorMessage: '',
        accessToken: action.payload.access_token,
        refreshToken: action.payload.refresh_token,
        customer: {
          id: action.payload.id,
          email: action.payload.email,
          name: `${action.payload.family_name}${action.payload.first_name}`,
          family_name: action.payload.family_name,
          first_name: action.payload.first_name,
          family_name_kana: action.payload.family_name_kana,
          first_name_kana: action.payload.first_name_kana,
          phone_number: action.payload.phone_number,
          zip_code: action.payload.zip_code,
          prefecture_id: action.payload.prefecture?.id,
          prefecture: action.payload.prefecture?.name,
          address_first: action.payload.address_first,
          address_second: action.payload.address_second,
          address_third: action.payload.address_third,
          masked_card_number: action.payload.masked_card_number,
          addresses: action.payload.customer_addresses,
          company_name: action.payload.company_name,
          company_url: action.payload.company_url,
          department: action.payload.department,
        },
        addresses: action.payload.customer_addresses,
        masked_card_number: action.payload.masked_card_number,
      };
    case CONST.LOGIN_FAILURE:
      return {
        ...state,
        isLoggedIn: false,
        errorMessage: 'Eメールかパスワードが正しくありません',
        accessToken: '',
        refreshToken: '',
        customer: null,
        addresses: null,
      };
    case CONST.UPDATE_CARD:
      return {
        ...state,
        masked_card_number: action.payload,
      };
    case CONST.COMPANY_INFO:
      return {
        ...state,
        company: action.payload,
      };
    // -----------------
    // リフレッシュトークンでログイン
    // -----------------
    case CONST.REFRESH_TOKEN_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        isFailure: false,
        errorMessage: '',
        customer: {
          id: action.payload.id,
          email: action.payload.email,
          name: `${action.payload.family_name}${action.payload.first_name}`,
          family_name: action.payload.family_name,
          first_name: action.payload.first_name,
          family_name_kana: action.payload.family_name_kana,
          first_name_kana: action.payload.first_name_kana,
          phone_number: action.payload.phone_number,
          zip_code: action.payload.zip_code,
          prefecture_id: action.payload.prefecture?.id,
          prefecture: action.payload.prefecture?.name,
          address_first: action.payload.address_first,
          address_second: action.payload.address_second,
          address_third: action.payload.address_third,
          masked_card_number: action.payload.masked_card_number,
          addresses: action.payload.customer_addresses,
          company_name: action.payload.company_name,
          company_url: action.payload.company_url,
          department: action.payload.department,
        },
        addresses: action.payload.customer_addresses,
        accessToken: action.payload.access_token,
        refreshToken: action.payload.refresh_token,
        masked_card_number: action.payload.masked_card_number,
      };
    case CONST.REFRESH_TOKEN_FAILURE:
      return {
        ...state,
        isLoggedIn: false,
        accessToken: '',
        refreshToken: '',
        customer: null,
        id: null,
        email: '',
        name: '',
        addresses: null,
      };
    // -----------------
    // 新規登録
    // -----------------
    case CONST.SIGN_UP_SUCCESS:
      return {
        ...state,
        isFailure: false,
        isSuccess: true,
        errorMessage: '',
      };
    case CONST.SIGN_UP_FAILURE:
      return {
        ...state,
        isSuccess: false,
        isFailure: true,
        errorMessage: action.payload,
      };
    case CONST.CLEAR_RESULT_FLG:
      return {
        ...state,
        isSuccess: false,
        isFailure: false,
        errorMessage: '',
      };
    case CONST.SEND_MAIL_RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        isFailure: false,
        isSuccess: true,
        errorMessage: '',
      };
    case CONST.SEND_MAIL_RESET_PASSWORD_FAILURE:
      return {
        ...state,
        isFailure: true,
        isSuccess: false,
        errorMessage: action.payload,
      };
    // -----------------
    // PW UPDATE
    // -----------------
    case CONST.UPDATE_PASSWORD_SUCCESS:
      return {
        ...state,
        isFailure: false,
        isSuccess: true,
        errorMessage: '',
      };
    case CONST.UPDATE_PASSWORD_FAILURE:
      return {
        ...state,
        isFailure: true,
        isSuccess: false,
        errorMessage: '',
      };
    default:
      return state;
  }
}

export default auth;
